import React from 'react';
import {Link} from 'react-router-dom';
import ReactTable from 'react-table';
import FontAwesome from 'react-fontawesome';
import ReactFireComponent from '../react-fire-component/react-fire-component';

export default class ExpoEditorDashboard extends ReactFireComponent {
  /** @constructor
    * Constructs a new instance of ExpoEditorDashboard
    */
  constructor(props) {
    super(props);
    this.state = {
      expos: []
    }
  }
  /** @method componentWillMount
    * Binds the component to the firebase database expo list
    */
  componentWillMount() {
    this.bindAsArray('/expos', 'expos');
  }
  /** @method componentWillUnmount
    * Unbinds the component from the firebase database
    */
  componentWillUnmount() {
    this.unbind('expos');
  }
  /** @method render
    * Renders the component
    */
  render() {
    const columns = [
      {Header: "Expo", accessor: "metadata.name"},
      {Header: "Website", accessor: "metadata.host", Cell: (row) => (
        <a href={`https://${row.value}`}>{row.value}</a>
      )},
      {Header: "Status", accessor: "metadata.status"},
      {Header: "# of Shows", accessor: "shows", Cell: (row) => (
        Object.keys(row.value || []).length
      )},
      {Header: "Action", accessor: "id", Cell: (row) => (
        <div style={{textAlign: "center"}}>
          <Link to={`/expos/${row.value}`}>
            <FontAwesome name="edit"
              style={{color: 'orange'}}
              />
          </Link>
        </div>
      )}
    ]
    const data = this.state.expos.filter(expo => {
      return true && expo.editors && expo.editors[this.props.uid]
    });
    return (
      <ReactTable
        className="-striped"
        data={data}
        columns={columns}
        defaultPageSize={15}
        />
    );
  }
}



// WEBPACK FOOTER //
// ./src/dashboard/expo-editor-dashboard.js